import { IconProp } from "@fortawesome/fontawesome-svg-core";
import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";
import React from "react";
import RoundButton from "features/shared/components/buttons/RoundButton";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IFileService from "data/IFileService";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { Dropdown } from "react-bootstrap";
import RoundDropdownButton from "features/shared/components/buttons/RoundDropdownButton";
import DropdownActionItem from "features/shared/components/dropdown/DropdownActionItem";

type Props = {
  id: string;
  icon: IconProp;
  documents: DocumentSimplifiedDTO[];
  formatTitle?: (document: DocumentSimplifiedDTO) => string;
};

const DocumentDownloadButton = ({
  id,
  icon,
  documents,
  formatTitle,
}: Props) => {
  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // hadlers
  const fileDownloadHandler = (document: DocumentSimplifiedDTO) => {
    fileService.downloadDocument(document);
  };

  // helpser
  const getDownloadTitle = (document: DocumentSimplifiedDTO): string => {
    if (formatTitle) {
      return formatTitle(document);
    } else {
      return document.name!;
    }
  };

  // sub-renders
  const renderDownloadActions = () => {
    return documents.map((item, index) => (
      <DropdownActionItem
        title={getDownloadTitle(item)}
        icon="download"
        onClick={() => fileDownloadHandler(item)}
        key={index}
      />
    ));
  };

  // render
  if (documents.length > 1) {
    return (
      <Dropdown>
        <RoundDropdownButton
          menuId={`document-download-button-menu-${id}`}
          icon={icon}
        />
        <Dropdown.Menu>{renderDownloadActions()}</Dropdown.Menu>
      </Dropdown>
    );
  } else if (documents.length === 1) {
    return (
      <RoundButton
        icon={icon}
        onClickHandler={() => fileDownloadHandler(documents[0])}
      />
    );
  } else {
    return <></>;
  }
};

export default DocumentDownloadButton;
